import ChatGPT from './ChatGPT';
import Survey from './Survey';

const index = {
  ChatGPT,
  Survey,
};

export default index;